import classnames from 'classnames';
import { useFormikContext } from 'formik';
import { useTranslation } from 'react-i18next';
import { useGetTariffPlans } from '@/query/queries/fundraising/useGetTariffPlans';
import { MyLink } from '@/components/MyLink';
import { APP_LINKS } from '@/helpers/links';
import { FundraisingCalculation } from '../../components/FundraisingCalculation';
import { VatWarning } from '../../components/VatWarning';
import Icon from './icon_back.svg';
import r from '@/kit/RoundButton/button.module.scss';
import s from './index.module.scss';

export const LenderStepPlanSelect = ({ manualTariffSet, companyId, selected, onBack, onNext }) => {
  const { data } = useGetTariffPlans(companyId);
  const { setFieldValue } = useFormikContext();
  const { t } = useTranslation();

  return (
    <div className={s.wrapper}>
      <div className={s.navigation}>
        <button type="button" onClick={onBack} className={s.btn_back}>
          <img src={Icon} alt="arrow" width={24} height={24} />
          {t('fundraising:step_plan_select.back')}
        </button>
      </div>
      <div className={s.content}>
        <div className="container-inner">
          <div className={s.inner}>
            <div className={s.header}>
              <h2 className="f-h2 f-500">{t('fundraising:step_plan_select.select_loan_terms')}</h2>
              <p className={classnames(s.desc, 'f-label')}>
                {t('fundraising:step_plan_select.review_available_plans')}{' '}
                <MyLink href={APP_LINKS.loanTermsPlans()} isExternal newWindow>
                  {t('fundraising:step_plan_select.learn_more')}
                </MyLink>
              </p>
            </div>
            <div>
              <div className={s.cards}>
                {data?.map(option => (
                  <div
                    key={option.id}
                    className={classnames(s.card, selected?.id === option.id && 'active')}
                    onClick={() => setFieldValue('tariff_plan', option)}
                  >
                    <h3 className="f-h3 f-500">{option.title}</h3>
                    <div className="f-label">{option.description}</div>
                    <div className={s.fee}>
                      <div className={s.fee_value}>{option.fee}%</div>
                      <div className={s.fee_label}>
                        <div>{t('fundraising:step_plan_select.fee_to_pay')}</div>
                        <div className="f-500">
                          {t('fundraising:step_plan_select.for_each_6_months')}
                        </div>
                      </div>
                    </div>
                    <div className={s.group}>
                      <div className="f-body f-500">{Number(option.monthly_repayment)}%</div>
                      <div className="f-label">
                        {t('fundraising:step_plan_select.monthly_repayment')}
                      </div>
                    </div>
                    <div className={s.group}>
                      <div className="f-body f-500">{Number(option.irr)}%</div>
                      <div className="f-label">
                        {t('fundraising:step_plan_select.effective_annual_cost_of_capital')}
                      </div>
                    </div>
                  </div>
                ))}
              </div>
              <VatWarning />
            </div>
            <FundraisingCalculation manualTariffSet={manualTariffSet} companyId={companyId} />
          </div>
          <div className={s.buttons}>
            <button type="button" className={r.black_large} onClick={onNext}>
              {t('fundraising:step_plan_select.next')}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};
